import alert from './alert'
import date from './date'
import file from './file'
import loading from './loading'

export default {
    install(Vue) {
        Vue.mixin(alert)
        Vue.mixin(date)
        Vue.mixin(file)
        Vue.mixin(loading)
    }
}
